<template>
  <div class="center OTcheckboxBulkContainer">
    <otif-checkbox v-model="positive" class="chkbox" />

    <b-dropdown class="OTdropdownBulk" variant="link">
      <b-dropdown-item @click="deleteSelectedDocuments()">Delete Document(s)</b-dropdown-item>
    </b-dropdown>

    <RemoveDocuments
      :job="job"
      :rows="rows"
      :row-number="rowNumber"
      :row="row"
      :deletefiles="deletefiles"
      v-model="deleteDocModal"
    />
  </div>
</template>
<script>
import RemoveDocuments from "@/components/jobEditing/localDocuments/RemoveDocuments.vue";
export default {
  props: ["job", "rows", "row", "rowNumber"],
  data() {
    return {
      deletefiles: [],
      deleteDocModal: false
    };
  },
  components: {
    RemoveDocuments
  },
  computed: {
    positive: {
      get() {
        return this.$store.state.localDocuments.checkAll;
      },
      set(val) {        
        for (var r = 0; r < this.rows.length; r++) {
          var row = this.rows[r];
          const payload = {
            documentId: r,
            documentName: row["1"],
            checked: false
          };
          this.$store.commit("localDocuments/PUSH_DOCUMENTS", payload);
        }

        this.$store.commit("localDocuments/CHECK_ALL_DOCUMENTS", val);
      }
    }
  },

  methods: {
    deleteSelectedDocuments() {
      this.deletefiles = [];
      this.deletefiles = this.$store.state.localDocuments.deletefiles;

      if (this.deletefiles.length > 0) {
        this.deleteDocModal = true;
      } else {
        this.$snotify.clear();
        this.$snotify.error("No documents detected.");
      }
    }
  }
};
</script>
<style scoped>
.center {
  position: absolute;
  margin-top: -29px !important;
}
.chkbox {
  position: absolute;
  margin-top: 2px !important;
}
</style>